import React, { useContext } from 'react';
import { AppDataContext } from '../../../contexts/appData';
import { usePreventBodyScroll } from '../../../libs';

const SelfTakeoutConfirmModal = ({ callback, data, ...props }) => {
  const { langs } = useContext(AppDataContext);

  const onAgree = () => {
    sessionStorage.setItem('selftakeout_terms_seen', 'true');
    callback(null, 'onAgree');
    callback(null, 'success')
    callback(null, 'destroy');
  };

  const onReject = () => {
    callback(null, 'onReject');
    callback(null, 'fail')
    callback(null, 'destroy');
  };

  // usePreventBodyScroll()

  return (
    <div
      className="custom-modal-wrapper delivery-terms-modal content-scroll_ hide-scrollbar"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '40px', minHeight: '560px' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', padding: '0 24px', width: '100%', marginTop: '70px', gap: '8px' }}>
        <span className={'font-bold text-black'} style={{ fontSize: '20px' }}>
          {langs.SelfTakeout_Title}
        </span>
        <span className={'font-base text-black-70'} style={{ fontSize: '14px' }}>
          {langs.SelfTakeout_Subtitle}
        </span>
      </div>
      <div style={{ display: 'flex', gap: '32px', flexDirection: 'column', alignItems: 'start', padding: '0 24px', width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', gap: '12px' }}>
          <span className={'svg-i terms-modal-place'} style={{ width: '32px', height: '32px' }} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '8px' }}>
            <span className={'font-medium text-black'} style={{ fontSize: '16px' }}>
              {langs.SelfTakeout_1}
            </span>
            <span className={'font-base text-black-70'} style={{ fontSize: '14px' }}>
              {langs.SelfTakeout_2}
            </span>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', gap: '12px' }}>
          <span className={'svg-i terms-modal-checkmark'} style={{ width: '32px', height: '32px' }} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '8px' }}>
            <span className={'font-medium text-black'} style={{ fontSize: '16px' }}>
              {langs.SelfTakeout_3}
            </span>
            <span className={'font-base text-black-70'} style={{ fontSize: '14px' }}>
              {langs.SelfTakeout_4}
            </span>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', gap: '12px' }}>
          <span className={'svg-i terms-modal-handshake'} style={{ width: '32px', height: '32px' }} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '8px' }}>
            <span className={'font-medium text-black'} style={{ fontSize: '16px' }}>
              {langs.SelfTakeout_5}
            </span>
            <span className={'font-base text-black-70'} style={{ fontSize: '14px' }}>
              {langs.SelfTakeout_6}
          </span>
          </div>
        </div>
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          gap: '12px',
          borderTop: '1px solid #EEE',
          padding: '0 24px',
          paddingTop: '16px',
        }}
      >
        <button
          className="btn font-size-14 w-100 font-bold"
          style={{ maxWidth: '140px', backgroundColor: '#f4f4f5', fontSize: '14px', color: '#272A37', borderRadius: '12px' }}
          onClick={onReject}
        >
          {langs.Reject}
        </button>
        <button
          className="btn font-size-14 w-100 font-bold"
          style={{ maxWidth: '140px', backgroundColor: '#fec900', fontSize: '14px', color: '#222', borderRadius: '12px' }}
          onClick={onAgree}
        >
          {langs.TradeInAgree}
        </button>
      </div>
    </div>
  );
};

export default SelfTakeoutConfirmModal;
